var map = {
	"./en.js": 1326,
	"./es.js": 1327,
	"./index.js": 702
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1325;


//////////////////
// WEBPACK FOOTER
// ./src/helper/ln nonrecursive \.js$
// module id = 1325
// module chunks = 37